var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',{class:[
    _vm.returnButtonTypeWhenIsMobile,
    _vm.icon === 'left' ? 'icon-left' : '',
    _vm.icon === 'right' ? 'icon-right' : '',
  ],attrs:{"href":_vm.href,"target":"_blank","rel":"noopener noreferrer"}},[_c('span',{staticClass:"icon"},[_vm._t("default")],2),_c('span',{staticClass:"sg-text"},[_vm._v(_vm._s(_vm.text))])]):(_vm.to)?_c('router-link',{class:[
    _vm.returnButtonTypeWhenIsMobile,
    _vm.icon === 'left' ? 'icon-left' : '',
    _vm.icon === 'right' ? 'icon-right' : '',
  ],attrs:{"to":_vm.to}},[_c('span',{staticClass:"icon"},[_vm._t("default")],2),_c('span',{staticClass:"sg-text"},[_vm._v(_vm._s(_vm.text))])]):_c('button',{class:[
    _vm.returnButtonTypeWhenIsMobile,
    _vm.icon === 'left' ? 'icon-left' : '',
    _vm.icon === 'right' ? 'icon-right' : '',
    _vm.loading ? 'loading' : '',
  ],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){return _vm.$emit('btnClick')}}},[(_vm.loading)?_c('EllipsisLoading',{staticClass:"ellipsis"}):_vm._e(),(!_vm.loading)?_c('span',{staticClass:"icon"},[_vm._t("default")],2):_vm._e(),(!_vm.loading)?_c('span',{staticClass:"sg-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }